import type { DocumentKind } from '@onefootprint/request-types/dashboard';
import type { VaultType } from '@/entities/hooks/use-entity-vault';

// The dashboard doesn't show capture videos yet, so decrypting one would fetch megabytes for nothing.
const getDocumentDataKinds = (dataKinds: VaultType['dataKinds'], kind: DocumentKind) =>
  Object.keys(dataKinds).filter(key => key.startsWith(`document.${kind}`) && !key.endsWith('.video'));

export default getDocumentDataKinds;
